// 全局锁变量
import store from "@/configure/store";
import {ElMessage, ElMessageBox} from "element-plus";
import router from "@/configure/router";
import {requestToken} from "@/util/adminRequest";

let messageBoxLock = false;
export const lesseeSelectFunction=function(type){
    try {
        if (type == "userNoLogin") {
            store.commit('deleteUserData')
            ElMessage.error("请重新登录")
            router.push('/indexAdminLogin')
        }
        if (type == "refresh-lessee") {
            if (messageBoxLock) return;
            messageBoxLock = true;
            ElMessageBox.alert('当前企业不可用', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                dangerouslyUseHTMLString: true // 启用 HTML 解析
            }).then(() => {
                listLesseeMainUserLessee()
            }).catch(() => {
            }).finally(() => {
                // 无论用户是点击确认、取消还是直接关闭弹窗，都释放锁
                messageBoxLock = false;
            });
        }
        if (type == "out-lessee") {
            if (messageBoxLock) return;
            messageBoxLock = true;
            ElMessageBox.alert('您已被管理员从企业内删除，相关数据已清空', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                dangerouslyUseHTMLString: true // 启用 HTML 解析
            }).then(() => {
                listLesseeMainUserLessee()
            }).catch(() => {
            }).finally(() => {
                // 无论用户是点击确认、取消还是直接关闭弹窗，都释放锁
                messageBoxLock = false;
            });
        }
    } catch (e) {
        console.log(e)
    }
}


//切换公司（获取所在租户列表）
const listLesseeMainUserLessee = function () {
    // 获取数据
    requestToken({
        url: '/Api/userSystem/LesseeUserModule/LesseeUser/ListLesseeMainUserLessee',
        data: {}
    }).then(res => {
        var lesseeMainUserLesseeList = res.data
        if (lesseeMainUserLesseeList.length > 0) {
            seletcLesseeClick(lesseeMainUserLesseeList[0])
        }else{
            store.commit('deleteUserData')
            router.push('/indexAdminLogin')
        }
    })
}

//选择公司
const seletcLesseeClick=function (data){
    updateLesseeUserMeta(data.lesseeUserID)
    store.commit('saveLesseeAdminToken', {
        lesseeAdminToken:data.memberLesseeTokenValue,
        lesseeAdminData:data
    })
    verifyLoginState()
    router.go(0);
}


//跟新登录时间
const updateLesseeUserMeta = function (lesseeUserID) {
    // 获取数据
    requestToken({
        url: '/Api/userSystem/PCLesseeMainModule/LesseeMainUser/UpdateLesseeUserMeta',
        data: {
            lesseeUserID: lesseeUserID
        }
    }).then(res => {
    })
}

// 校验管理后台登录状态
const verifyLoginState = function () {
    requestToken({
        url: '/Api/userSystem//LesseeMainModule/LesseeMainUserLogin/AuthorityData',
        data: {}
    }).then(res => {
        store.commit('saveUserAuthorityData', {
            authorityData: res.data,
        })
    })
}
